import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Typography,
  makeStyles,
  colors
} from '@material-ui/core';
import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck';
import RehabPhaseTracker from './RehabPhaseTracker';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: "#002D55",
    height: 50,
    width: 50
    
  }
}));

const CurrentSessionTracker = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item xs={11}>
            <Typography
              style={{color: "#002D55", marginBottom: 5, marginTop: 5}}
              variant="h4"
            >
              Current session:
            </Typography>
            <Typography
              style={{color: "#002D55", marginTop: 15}}
              variant="h4"
            >
              75.5%
            </Typography>
            <Box mt={1}>
              <LinearProgress
              value={75.5}
              variant="determinate"
              />
            </Box>
            <Typography
              style={{marginTop: 0, marginBottom: 5}}
              color="textSecondary"
              gutterBottom
              variant="h7"
              xs={10}
            >
              completed of current session. Great job!<br/><br/>
               Keep going, and click "Complete session" when you are all done. 
            </Typography>
          </Grid>
          <Grid item>
            <RehabPhaseTracker/>
          </Grid>
        </Grid>
      
  );
};

CurrentSessionTracker.propTypes = {
  className: PropTypes.string
};

export default CurrentSessionTracker;